import _Vue, { PluginObject } from 'vue';

declare module 'vue/types/vue' {
  interface Vue {
    $externalPage: {
      show(externalPageContent: ExternalPageContent): ExternalPageInstance;
    };
  }
}

export interface ExternalPageContent {
  name: string;
  url?: string;
  video?: string;
  bookmark?: number;
  html?: string;
  onClose?(data?: unknown): void;
}

interface ExternalPagePluginObject extends PluginObject<_Vue> {
  EventBus: _Vue | undefined;
  externalPages: ExternalPageInstance[];
}

export class ExternalPageInstance {
  public events: _Vue = new _Vue();

  public content: ExternalPageContent;

  constructor(externalPageContent: ExternalPageContent) {
    this.content = externalPageContent;
  }

  public dismiss(data?: unknown) {
    this.events.$emit('dismiss');
    if (this.content.onClose) this.content.onClose(data);
  }
}

const ExternalPagePlugin: ExternalPagePluginObject = {
  EventBus: undefined,
  externalPages: [],
  install: (Vue: typeof _Vue) => {
    ExternalPagePlugin.EventBus = new Vue();
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$externalPage = {
      show(externalPageContent: ExternalPageContent) {
        const externalPage = new ExternalPageInstance(externalPageContent);
        externalPage.events.$once('dismiss', () => {
          ExternalPagePlugin.externalPages = ExternalPagePlugin.externalPages.filter(
            (externalPageEntry: ExternalPageInstance) =>
              externalPageEntry !== externalPage
          );
          if (ExternalPagePlugin.EventBus) {
            ExternalPagePlugin.EventBus.$emit(
              'externalPages',
              ExternalPagePlugin.externalPages
            );
          }
        });
        ExternalPagePlugin.externalPages.unshift(externalPage);
        if (ExternalPagePlugin.EventBus) {
          ExternalPagePlugin.EventBus.$emit(
            'externalPages',
            ExternalPagePlugin.externalPages
          );
        }
        return externalPage;
      },
    };
  },
};

export default ExternalPagePlugin;
